module.exports={
	"⌥": 18, "alt": 18, "option": 18,
	"backspace": 8,
	"capslock": 20, "caps": 20,
	"clear": 12,
	"context": 93,
	"⌘": 91, "cmd": 91, "command": 91,
	"⌃": 17, "ctrl": 17, "control": 17,
	"del": 46, "delete": 46,
	"down": 40,
	"end": 35,
	"⎆": 13, "enter": 13, "return": 13,
	"esc": 27, "escape": 27,
	"home": 36,
	"insert": 45,
	"left": 37,
	"pagedown": 34, "pg-down": 34,
	"pageup": 33, "pg-up": 33,
	"pause": 19,
	"right": 39,
	"⇧": 16, "shift": 16,
	"space": 32,
	"tab": 9,
	"up": 38,

	"F1": 112,
	"F2": 113,
	"F3": 114,
	"F4": 115,
	"F5": 116,
	"F6": 117,
	"F7": 118,
	"F8": 119,
	"F9": 120,
	"F10": 121,
	"F11": 122,
	"F12": 123,

	"leftmouse": 1,
	"rightmouse": 3,
	"middlemouse": 2,

	"*": 106,
	"+": 107, "plus": 107,
	"-": 109, "minus": 109,
	";": 186, "semicolon": 186,
	"=": 187, "equals": 187,
	",": 188,
	"dash": 189,
	".": 190,
	"/": 191,
	"`": 192, "~": 192,
	"[": 219,
	"\\": 220,
	"]": 221,
	"'": 222
}